<app-navbar-view
  [gameName]="gameName()"
  [gameId]="gameId()"
  [tabs]="tabs()"
  [balance]="balance()"
  [selectedTabIndex]="selectedTabIndex"
  [displayedPendingCount]="displayedPendingCount()"
  [displayedShowDot]="displayedShowDot()"
  [showBalance]="showBalance()"
  (closeClickedEvent)="onCloseClicked()"
  (tabSelectedEvent)="onTabSelected($event)"
/>
